import React, { Suspense, Component, useContext, useState } from 'react';
import { useQuery, useMutation } from '@apollo/client/react';

import { addToCartAnalytics } from '../../helpers/analytics.js';

import { CheckoutContext } from "../../context/CheckoutContext";
import { CartOpenContext } from "../../context/CartOpenContext";
import classNames from 'classnames';

import {
  shopProducts,
} from '../../graphql/shopQuery';

import {
  useCheckoutEffect,
  checkoutLineItemsAdd,
} from '../../graphql/checkoutQuery';

const VARIANT_QTY = 1; // can only add one at a time

function GiftCard(props){

  const product = props.getProduct( SHOPIFY_GQL_GIFTCARD_ID );

  if( !product ){
    return <div>loading</div>;
  }

  const defaultVariant = product.variants.edges[0].node;

  const [variant,setVariant] = useState(defaultVariant);

  const handleOptionChange = (value) => {

    const selectedVariant = product.variants.edges.find((variant) => {
      return variant.node.selectedOptions.every((selectedOption) => {
        return value === selectedOption.value;
      });
    }).node;

    setVariant(selectedVariant);
  }

  const addToCart = () => {
    props.addVariantToCart(variant.id, VARIANT_QTY);

    // add to cart event
    let analyticsName = `gift-card`;
    addToCartAnalytics(variant.id, variant.price.amount, VARIANT_QTY, analyticsName);
  };

  return (
      <>
        <div className="row options-header">
          <div className="col d-flex justify-content-center">
            <select
              className="denom-select"
              onChange={event=>handleOptionChange(event.target.value)}
            >
            {product.options[0].values.map((value) => {

              let variantOptionValue = variant.selectedOptions.find( option => option.name === option.name ).value;

              const classes = classNames('banana', { 'selected': variantOptionValue === value });
              return (<option
                  key={`denom-${value}`}
                  className={classes}
                  value={`${value}`}
                >
                {`${value}`}
              </option>)
            })}
            </select>
          </div>
        </div>
        <div className="row options-header">
          <div className="col">
            <p className="header-btn">
              {props.lineItemAddLoading
                ? <button className="btn btn-primary btn-light" disabled="disabled">ADD TO CART</button>
                : <button className="btn btn-primary btn-light" onClick={addToCart}>ADD TO CART</button>
              }
            </p>
          </div>
        </div>
      </>
  );
}
export default GiftCard;
